/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceConfigurationSchemaDto
 */
export interface DeviceConfigurationSchemaDto {
    /**
     *
     * @type {number}
     * @memberof DeviceConfigurationSchemaDto
     */
    deviceConfigurationSchemaId?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationSchemaDto
     */
    deviceType?: DeviceConfigurationSchemaDtoDeviceTypeEnum;
    /**
     * Config applies to device model names starting with this text.
     * @type {string}
     * @memberof DeviceConfigurationSchemaDto
     */
    model?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationSchemaDto
     */
    key?: string;
    /**
     * eg Int32, Decimal, Boolean, String, Enum.<EnumName> (eg 'Enum.ChargerWiringMode'), NumberOrKeepExisting (for Wave config int fields that may also be 'KEEP_EXISTING'). Ends with '?' if the number or enum is optional.
     * @type {string}
     * @memberof DeviceConfigurationSchemaDto
     */
    dataType?: string;
    /**
     * Optional. The range of allowed values for a number, or the list of allowed enums. Prefer DisplayValuesMapping for display, if set. eg: Int32: [0,100], Decimal: [0,99.9], Boolean: null, Enum.ChargerWiringMode: ['SINGLE_PHASE_L1','SINGLE_PHASE_L2','SINGLE_PHASE_L3','THREE_PHASE'], NumberOrKeepExisting: [0,100]
     * @type {string}
     * @memberof DeviceConfigurationSchemaDto
     */
    values?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceConfigurationSchemaDto
     */
    description?: string;
    /**
     * True to show this config item in the provisioning workflow for this device type/model
     * @type {boolean}
     * @memberof DeviceConfigurationSchemaDto
     */
    showDuringProvisioning?: boolean;
    /**
     * True if this is an Illuminate-only key, that is not sent to the Device
     * @type {boolean}
     * @memberof DeviceConfigurationSchemaDto
     */
    illuminateOnly?: boolean;
    /**
     * user-facing label. May include units, eg 'Max Grid Supply Current (A)'
     * @type {string}
     * @memberof DeviceConfigurationSchemaDto
     */
    label?: string;
    /**
     * List of display names to show in a drop-down in-order, with a colon separating them from their values. Eg ['Single Phase:1','Three Phase:3']. This is for display only. All validation and set apis use the true value. If null, fall back to Values field.
     * @type {string}
     * @memberof DeviceConfigurationSchemaDto
     */
    displayNamesMapping?: string;
}

/**
 * @export
 */
export const DeviceConfigurationSchemaDtoDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type DeviceConfigurationSchemaDtoDeviceTypeEnum =
    (typeof DeviceConfigurationSchemaDtoDeviceTypeEnum)[keyof typeof DeviceConfigurationSchemaDtoDeviceTypeEnum];

/**
 * Check if a given object implements the DeviceConfigurationSchemaDto interface.
 */
export function instanceOfDeviceConfigurationSchemaDto(
    value: object,
): value is DeviceConfigurationSchemaDto {
    return true;
}

export function DeviceConfigurationSchemaDtoFromJSON(
    json: any,
): DeviceConfigurationSchemaDto {
    return DeviceConfigurationSchemaDtoFromJSONTyped(json, false);
}

export function DeviceConfigurationSchemaDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConfigurationSchemaDto {
    if (json == null) {
        return json;
    }
    return {
        deviceConfigurationSchemaId:
            json["deviceConfigurationSchemaId"] == null
                ? undefined
                : json["deviceConfigurationSchemaId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        model: json["model"] == null ? undefined : json["model"],
        key: json["key"] == null ? undefined : json["key"],
        dataType: json["dataType"] == null ? undefined : json["dataType"],
        values: json["values"] == null ? undefined : json["values"],
        description:
            json["description"] == null ? undefined : json["description"],
        showDuringProvisioning:
            json["showDuringProvisioning"] == null
                ? undefined
                : json["showDuringProvisioning"],
        illuminateOnly:
            json["illuminateOnly"] == null ? undefined : json["illuminateOnly"],
        label: json["label"] == null ? undefined : json["label"],
        displayNamesMapping:
            json["displayNamesMapping"] == null
                ? undefined
                : json["displayNamesMapping"],
    };
}

export function DeviceConfigurationSchemaDtoToJSON(
    value?: DeviceConfigurationSchemaDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceConfigurationSchemaId: value["deviceConfigurationSchemaId"],
        deviceType: value["deviceType"],
        model: value["model"],
        key: value["key"],
        dataType: value["dataType"],
        values: value["values"],
        description: value["description"],
        showDuringProvisioning: value["showDuringProvisioning"],
        illuminateOnly: value["illuminateOnly"],
        label: value["label"],
        displayNamesMapping: value["displayNamesMapping"],
    };
}
